import React, {useCallback, useEffect, useState} from 'react';
import close from "../../../images/close.svg";
import {Field, Formik} from "formik";
import plus from "../../../images/blue-plus.svg";
import arrowDown from "../../../images/input-arrow.svg";
import infoIcon from "../../../images/info-circle.svg";
import calendar from "../../../images/calendar.svg";
import {fromDateToStringDate, getFormattedDate, isCyrilic, testDate} from "../../../utils";
import {Calendar} from "react-date-range";
import line from "../../../images/line.svg";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {getCommonData} from "../../../redux/data/data-thunks";
import {COUNTRIES, LICENSE_SYSTEMS, LICENSE_TYPES} from "../../../redux/data/data-types";
import * as Yup from "yup";
import {addLicense, editLicense, getIytLicenses} from "../../../redux/profile/profile-thunks";
import {userApi} from "../../../redux/user/user-api";
import {useTranslation} from "react-i18next";
import InputMask from 'react-input-mask';

const AddLicense = ({closeModal, editItem, openIytModal, ...props}) => {
  const {t} = useTranslation()
  const [startDate, setStartDate] = useState(editItem ? new Date(editItem.issue_date) : null)
  const {isDark} = useTheme()
  const [finishDate, setFinishDate] = useState(editItem?.expiry_date ? new Date(editItem.expiry_date) : null)
  const [frontImageFileName, setFrontImageFileName] = useState('')
  const [backImageFileName, setBackImageFileName] = useState('')
  const fetchPhotos = useCallback(async () => {
    let frontResponse, backResponse = null
    if (editItem.front_image_id) {
      frontResponse = await userApi.getFileInfo(editItem.front_image_id)
      setFrontImageFileName(frontResponse.data.filename)
    }
    if (editItem.back_image_id) {
      backResponse = await userApi.getFileInfo(editItem.back_image_id)
      setBackImageFileName(backResponse.data.filename)
    }
  }, [])
  useEffect(() => {
    props.getCommonData(LICENSE_SYSTEMS)
    if (editItem) {
      fetchPhotos()
      props.getCommonData(COUNTRIES, editItem.country?.name)
      props.getCommonData(LICENSE_TYPES, editItem.license_type.name)
    } else {
      props.getCommonData(COUNTRIES)
      props.getCommonData(LICENSE_TYPES)
    }
  }, [])
  useEffect(() => {
    if (props.iytLicenses !== null) {
      openIytModal()
      closeModal()
    }
  }, [props.iytLicenses])
  const onSubmit = async (values, {setFieldError}) => {
    let country = props.countries.find(c => c.name === values.country)
    let licenseType = props.licenseTypes.find(l => l.name === values.licenseType)
    let licenseSystem = props.licenseSystems.find(l => l.name === values.licenseSystem)
    let isAnyError = false
    let name = ''
    if (values.licenseSystem === 'Other' && !country) {
      isAnyError = true
      setFieldError('country', t('countryNotFound'))
    }
    if (!licenseType) {
      // isAnyError = true
      // setFieldError('licenseType', t('licenseTypeNotFound'))
      if(!isCyrilic(values.licenseType)) {
        isAnyError = true
        setFieldError('licenseType', `${t('enter')} ${t('licenseType')} ${t('onlyEnglish')}`)
      }
      name = values.licenseType
    }
    if (!isCyrilic(values.school)) {
      isAnyError = true
      setFieldError('school', `${t('enter')} ${t('sailSchool')} ${t('onlyEnglish')}`)
    }
    if (!isCyrilic(values.instructor)) {
      isAnyError = true
      setFieldError('instructor', `${t('enter')} ${t('instructor')} ${t('onlyEnglish')}`)
    }
    if (!isCyrilic(values.number)) {
      isAnyError = true
      setFieldError('number', `${t('enter')} ${t('licenseNumber')} ${t('onlyEnglish')}`)
    }
    if (!isCyrilic(values.org)) {
      isAnyError = true
      setFieldError('org', `${t('enter')} ${t('organization')} ${t('onlyEnglish')}`)
    }
    if(values.dateFrom.length !== 10 && !testDate(values.dateFrom)) {
      isAnyError = true
      setFieldError('dateFrom', t('invalidDate'))
    }
    if(!values.isInfinite && values.dateTo.length !== 10 && !testDate(values.dateTo)) {
      isAnyError = true
      setFieldError('dateTo', t('invalidDate'))
    }
    // if(!values.frontImageFile && !frontImageFileName) {
    //   isAnyError = true
    //   setFieldError('frontImageFile', 'Пожалуйста, выберите фото передней части лицензии')
    // }
    // if(!values.backImageFile && !backImageFileName) {
    //   isAnyError = true
    //   setFieldError('backImageFile', 'Пожалуйста, выберите фото задней части лицензии')
    // }
    if (!isAnyError) {
      let frontResponse, backResponse
      if (values.frontImageFile) {
        frontResponse = await userApi.uploadFile(values.frontImageFile)
      }
      if (values.backImageFile) {
        backResponse = await userApi.uploadFile(values.backImageFile)
      }
      const body = {
        name: name ?? `${getFormattedDate(startDate)}-${getFormattedDate(finishDate)} ${values.number}`,
        license_system_id: licenseSystem.id,
        license_type_id: licenseType?.id ?? null,
        country_id: country ? country.id : null,
        issuer_name: values.org ?? null,
        license_number: values.number,
        school_name: values.school ?? null,
        instructor_name: values.instructor ?? null,
        issue_date: getFormattedDate(startDate),
        expiry_date: values.isInfinite ? null : getFormattedDate(finishDate),
        front_image_id: frontResponse ? frontResponse.data.id : editItem?.front_image_id ?? null,
        back_image_id: backResponse ? backResponse.data.id : editItem?.back_image_id ?? null
      }
      if (editItem) {
        props.editLicense(body, editItem.id)
      } else {
        props.addLicense(body)
      }
      closeModal()
    }
  }
  return (
    <div style={{width: 682}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5 className="modal__title mr-30">{editItem === null ? t('addLicense') : t('editLicense')}</h5>
      <Formik
        initialValues={{
          licenseSystem: editItem?.license_system?.name ?? '',
          licenseType: editItem?.license_type?.name ?? '',
          number: editItem?.license_number ?? '',
          dateFrom: editItem ? fromDateToStringDate(editItem?.issue_date) : null,
          isInfinite: editItem ? editItem.expiry_date === null : false,
          dateTo: editItem?.expiry_date ? fromDateToStringDate(editItem?.expiry_date) : null,
          country: editItem?.country?.name ?? '',
          org: editItem?.issuer_name ?? '',
          school: editItem?.school_name ?? '',
          instructor: editItem?.instructor_name ?? '',
          frontImageFile: null,
          backImageFile: null,
          iytId: ''
        }}
        onSubmit={onSubmit}
      >
        {({
            values, handleChange, handleSubmit, setFieldValue,
            errors, ...formikProps
          }) => {
          const isFirstScriptValid = values.licenseType && values.number && values.dateFrom
            && (values.dateTo || values.isInfinite) && values.licenseSystem
          const isSecondScriptValid = values.licenseSystem === 'Other' && values.country // && values.org
            && values.number && values.dateFrom
            && (values.dateTo || values.isInfinite) && values.licenseType
          return <>
            <div className="modal__sections">
              <div className={'modal__section'}>
                <div className="modal__inputs show-block">
                  <div className="modal__inputItem">
                    <p className="modal__label">{t('licenseSystem')}: <span className={'required'}>*</span></p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete="off" placeholder={t('notChosen')} value={values.licenseSystem}
                             id={'licenseSystem'} onChange={() => {
                      }} type="text"
                             className={`modal__input w-100`}/>
                      <button className="modal__arrowIcon">
                        <img src={arrowDown} alt=""/>
                      </button>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.licenseSystems.map((system, index) => <button className="modal__listItem" key={index}
                                                                               onClick={() => {
                                                                                 setFieldValue('licenseSystem', system.name)
                                                                                 props.getCommonData(LICENSE_TYPES, undefined, undefined, `&license_system_id=${system.id}`)
                                                                               }}>
                            {system.name}
                          </button>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {values.licenseSystem === 'IYT' && <div className="modal__inputItem">
                    <p className="modal__label">IYT ID:</p>
                    <div className="modal__inputWrapper w-100">
                      <Field placeholder={'IYT ID'} onBlur={(e) => {
                        if (e.target.value > 0) props.getIytLicenses(values.iytId)
                      }}
                             value={values.iytId} id={'iytId'} type="text" className={`modal__input w-100`}/>
                    </div>
                  </div>}
                  {values.licenseSystem === 'Other' && <>
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('country')}: <span className={'required'}>*</span></p>
                      <div className="modal__inputWrapper w-100">
                        <Field autoComplete="off" placeholder={t('notChosen')} value={values.country}
                               id={'country'} onChange={e => {
                          handleChange(e)
                          props.getCommonData(COUNTRIES, e.target.value)
                        }} type="text"
                               className={`modal__input w-100 ${errors.country && 'modal__inputError'}`}/>
                        <button className="modal__arrowIcon">
                          <img src={arrowDown} alt=""/>
                        </button>
                        <div className="modal__list">
                          <div className="modal__listItems">
                            {props.countries.map((country, index) => <button className="modal__listItem" key={index}
                                                                             onClick={() => setFieldValue('country', country.name)}>
                              {country.name}
                            </button>)}
                          </div>
                        </div>
                      </div>
                    </div>
                    {errors.country && <div className={'modal__inputItem mt-0'}>
                      <p className="modal__label"/>
                      <p className="modal__errorText">{errors.country}</p>
                    </div>}
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('organization')}:</p>
                      <div className="modal__inputWrapper w-100">
                        <Field autoComplete="off" placeholder={t('enterOrg')} value={values.org}
                               id={'org'} onChange={e => {
                          if (e.target.value.length < 100) {
                            handleChange(e)
                          }
                        }} type="text"
                               className={`modal__input w-100 ${errors.org && 'modal__inputError'}`}/>
                      </div>
                    </div>
                    {errors.org && <div className={'modal__inputItem mt-0'}>
                      <p className="modal__label"/>
                      <p className="modal__errorText">{errors.org}</p>
                    </div>}
                  </>}
                  <div className="modal__inputItem">
                    <p className="modal__label">{t('licenseNumber')}: <span className={'required'}>*</span></p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete="off" placeholder={t('licenseNumber')} value={values.number}
                             id={'number'} onChange={e => {
                        if (e.target.value.length < 100) {
                          handleChange(e)
                        }
                      }} type="text"
                             className={`modal__input w-100 ${errors.number && 'modal__inputError'}`}/>
                    </div>
                  </div>
                  {errors.number && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.number}</p>
                  </div>}
                  <div className="modal__inputItem">
                    <p className="modal__label">{t('licenseType')}: <span className={'required'}>*</span></p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete="off" placeholder={t('chooseLicenseType')} value={values.licenseType}
                             id={'licenseType'} onChange={e => {
                        handleChange(e)
                        props.getCommonData(LICENSE_TYPES, e.target.value)
                      }} type="text"
                             className="modal__input w-100"/>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.licenseTypes.map((type, index) => <button className="modal__listItem" key={index}
                                                                           onClick={() => setFieldValue('licenseType', type.name)}>
                            {type.name}
                          </button>)}
                        </div>
                      </div>
                      <button className="modal__arrowIcon">
                        <img src={arrowDown} alt=""/>
                      </button>
                    </div>
                  </div>
                  {values.licenseSystem !== 'Other' && <>
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('sailSchool')}:</p>
                      <div className="modal__inputWrapper w-100">
                        <Field autoComplete="off" placeholder={t('notChosen')} value={values.school}
                               id={'school'} onChange={e => {
                          if (e.target.value.length < 100) {
                            handleChange(e)
                          }
                        }} type="text"
                               className={`modal__input w-100 ${errors.school && 'modal__inputError'}`}/>
                        <button className="modal__arrowIcon">
                          <img src={arrowDown} alt=""/>
                        </button>
                      </div>
                    </div>
                    {errors.school && <div className={'modal__inputItem mt-0'}>
                      <p className="modal__label"/>
                      <p className="modal__errorText">{errors.school}</p>
                    </div>}
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('instructor')}:</p>
                      <div className="modal__inputWrapper w-100">
                        <Field autoComplete="off" placeholder={t('notChosen')} value={values.instructor}
                               id={'instructor'} onChange={e => {
                          if (e.target.value.length < 100) {
                            handleChange(e)
                          }
                        }} type="text"
                               className={`modal__input w-100 ${errors.instructor && 'modal__inputError'}`}/>
                        <button className="modal__arrowIcon">
                          <img src={arrowDown} alt=""/>
                        </button>
                      </div>
                    </div>
                    {errors.instructor && <div className={'modal__inputItem mt-0'}>
                      <p className="modal__label"/>
                      <p className="modal__errorText">{errors.instructor}</p>
                    </div>}
                  </>}
                  <div className="modal__uploadWrapper">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('issueDate')}: <span className={'required'}>*</span></p>
                      <div className={`modal__date w-260 ${errors.dateFrom && 'modal__inputError'}`}>
                        <div className="modal__dateItem m-0">
                          <InputMask mask={'99.99.9999'} maskChar={''} permanents={[2, 5]}
                                     placeholder={t('chooseIssueDate')} className={'modal__dateInput'} type="text"
                                     id={'dateFrom'} autoComplete={'off'}
                                     value={values.dateFrom !== '...' ? values.dateFrom : ''}
                                     onChange={(e) => {
                                       handleChange(e)
                                       if (e.target.value.length === 10) {
                                         if (/(0[0-9]|1\d|2\d|3[01])\.(0[0-9]|1[0-2])\.(19|20)\d{2}$/.test(e.target.value)) {
                                           let date = e.target.value.split('.')
                                           setStartDate(new Date(date[2], +date[1] - 1, date[0]))
                                         } else {
                                           formikProps.setFieldError('dateFrom', t('invalidDate'))
                                         }
                                       }
                                     }}/>
                          <div className="modal__calendar">
                            <Calendar onChange={item => {
                              setFieldValue('dateFrom', fromDateToStringDate(getFormattedDate(item)))
                              setStartDate(item)
                            }} date={startDate}/>
                          </div>
                          <img src={calendar} alt="" className="modal__dateIcon"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.dateFrom && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.dateFrom}</p>
                  </div>}
                  <div className="modal__inputItem mt-16">
                    <p className="modal__label"/>
                    <CustomCheckBox isDark={isDark} isChecked={values.isInfinite}
                                    onClick={() => {
                                      setFieldValue('dateTo', null)
                                      setFinishDate(null)
                                      setFieldValue('isInfinite', !values.isInfinite)
                                    }}
                                    caption={t('unlimited')} fontFamily={'Lato400'} color={'#252526'}
                                    marginBottom={'0px'}/>
                  </div>
                  <div className="modal__uploadWrapper">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('expiryDate')}: <span className={'required'}>*</span></p>
                      <div className={`modal__date w-260 ${errors.dateTo && 'modal__inputError'}`}>
                        <div className="modal__dateItem m-0">
                          <InputMask mask={'99.99.9999'} maskChar={''} permanents={[2, 5]}
                                     autoComplete={'off'}
                                     disabled={values.isInfinite} placeholder={t('chooseExpiryDate')}
                                     className={'modal__dateInput'} type="text" id={'dateTo'}
                                     value={values.dateTo !== '...' ? values.dateTo : ''}
                                     onChange={(e) => {
                                       handleChange(e)
                                       if (e.target.value.length === 10) {
                                         if (/(0[0-9]|1\d|2\d|3[01])\.(0[0-9]|1[0-2])\.(19|20)\d{2}$/.test(e.target.value)) {
                                           let date = e.target.value.split('.')
                                           setFinishDate(new Date(date[2], +date[1] - 1, date[0]))
                                         } else {
                                           formikProps.setFieldError('dateTo', t('invalidDate'))
                                         }
                                       }
                                     }}/>
                          <div className="modal__calendar">
                            <Calendar onChange={item => {
                              setFieldValue('dateTo', fromDateToStringDate(getFormattedDate(item)))
                              setFinishDate(item)
                            }} date={finishDate} minDate={startDate}/>
                          </div>
                          <img src={calendar} alt="" className="modal__dateIcon"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.dateTo && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.dateTo}</p>
                  </div>}
                  <div className="modal__uploadWrapper">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('frontSide')}:</p>
                      <div className="modal__upload">
                        <div className={`modal__uploadInner ${errors.frontImageFile && 'modal__inputError'}`}>
                          <p
                            className="modal__uploadText">{values.frontImageFile ? values.frontImageFile.name : frontImageFileName ?? t('fileNotChosen')}</p>
                          <label htmlFor={'file1'} className="modal__uploadButton">{t('choosePhoto')}</label>
                          <input onChange={e => setFieldValue('frontImageFile', e.target.files[0])} id={'file1'}
                                 type="file" className={'modal__file'}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.frontImageFile && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.frontImageFile}</p>
                  </div>}
                  <div className="modal__uploadWrapper">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('backSide')}:</p>
                      <div className={`modal__upload`}>
                        <div className={`modal__uploadInner ${errors.backImageFile && 'modal__inputError'}`}>
                          <p
                            className="modal__uploadText">{values.backImageFile ? values.backImageFile.name : backImageFileName ?? t('fileNotChosen')}</p>
                          <label htmlFor={'file2'} className="modal__uploadButton">{t('choosePhoto')}</label>
                          <input onChange={e => setFieldValue('backImageFile', e.target.files[0])} id={'file2'}
                                 type="file" className={'modal__file'}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.backImageFile && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.backImageFile}</p>
                  </div>}
                </div>
              </div>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button disabled={!((values.licenseSystem !== 'Other' && isFirstScriptValid)
                  || (values.licenseSystem === 'Other' && isSecondScriptValid))}
                        className={`${((values.licenseSystem !== 'Other' && isFirstScriptValid)
                          || (values.licenseSystem === 'Other' && isSecondScriptValid)) ? 'submit-button' : 'submit-button__disabled'}`}
                        onClick={handleSubmit}>
                  {editItem === null ? t('add') : t('save')}
                </button>
                <button className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
              </div>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  countries: state.dataReducer.countries,
  licenseTypes: state.dataReducer.licenseTypes,
  licenseSystems: state.dataReducer.licenseSystems,
  iytLicenses: state.profileReducer.iytLicenses
})

export default connect(mapStateToProps, {
  getCommonData,
  addLicense,
  editLicense,
  getIytLicenses
})(React.memo(AddLicense));
